module.exports = __webpack_public_path__ + "static/media/icon-fb.b453fcc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-fb.svg
// module id = 912
// module chunks = 0